import React, { useEffect, useState } from "react";
//for rendering custom pagination
function CustomPagination({ totalPages, setPageNum, activePage }) {
  const [currentPage, setCurrentPage] = useState(1);
  useEffect(() => {
    // This effect will run whenever activePage changes
    setCurrentPage(activePage);
  }, [activePage]);
  // Handle page change
  const handleChange = (page) => {
    setCurrentPage(page);
    setPageNum(page);
  };
  // Handle previous page click
  const previousPage = () => {
    if (currentPage > 1) {
      handleChange(currentPage - 1);
    }
  };
  // Handle next page click
  const nextPage = () => {
    if (currentPage < totalPages) {
      handleChange(currentPage + 1);
    }
  };
  // Function to create a range of page numbers with ellipsis
  // const getPageNumbers = () => {
  //   const maxPageNumbersToShow = 5; // Max pages to show in the pagination
  //   const pages = [];
  //   let startPage, endPage;
  //   if (totalPages <= maxPageNumbersToShow) {
  //     // Show all pages if total pages are less than maxPageNumbersToShow
  //     startPage = 1;
  //     endPage = totalPages;
  //   } else {
  //     // Calculate the start and end pages to show
  //     const maxPagesBeforeCurrentPage = Math.floor(maxPageNumbersToShow / 2);
  //     const maxPagesAfterCurrentPage = Math.ceil(maxPageNumbersToShow / 2) - 1;
  //     if (currentPage <= maxPagesBeforeCurrentPage) {
  //       startPage = 1;
  //       endPage = maxPageNumbersToShow;
  //     } else if (currentPage + maxPagesAfterCurrentPage >= totalPages) {
  //       startPage = totalPages - maxPageNumbersToShow + 1;
  //       endPage = totalPages;
  //     } else {
  //       startPage = currentPage - maxPagesBeforeCurrentPage;
  //       endPage = currentPage + maxPagesAfterCurrentPage;
  //     }
  //   }
  //   // Add first page and ellipsis if startPage is greater than 1
  //   if (startPage > 1) {
  //     pages.push(1);
  //     if (startPage > 2) {
  //       pages.push("...");
  //     }
  //   }
  //   // Add range of page numbers
  //   for (let i = startPage; i <= endPage; i++) {
  //     pages.push(i);
  //   }
  //   // Add last page and ellipsis if endPage is less than totalPages
  //   if (endPage < totalPages) {
  //     if (endPage < totalPages - 1) {
  //       pages.push("...");
  //     }
  //     pages.push(totalPages);
  //   }
  //   return pages;
  // };

  // Function to create a range of page numbers with ellipsis
  const getPageNumbers = () => {
    const maxPageNumbersToShow = 5; // Max pages to show in the pagination
    const pages = [];
    let startPage, endPage;
    if (totalPages <= maxPageNumbersToShow) {
      // Show all pages if total pages are less than maxPageNumbersToShow
      startPage = 1;
      endPage = totalPages;
      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }
    } else {
      // Calculate the start and end pages to show
      const maxPagesBeforeCurrentPage = 0;
      const maxPagesAfterCurrentPage = 0;

      if (currentPage <= maxPagesBeforeCurrentPage) {
        startPage = 1;
        endPage = maxPageNumbersToShow;
      } else if (currentPage + maxPagesAfterCurrentPage >= totalPages) {
        startPage = currentPage - 1;
        endPage = totalPages;
      } else {
        startPage = currentPage - maxPagesBeforeCurrentPage;
        endPage = currentPage + maxPagesAfterCurrentPage;
      }
      // Add first page and ellipsis if startPage is greater than 1
      pages.push(1);
      pages.push(2);
      if (startPage > 3) {
        pages.push("..");
      }
      // Add range of page numbers
      if (startPage > 2) {
        for (let i = startPage; i <= endPage; i++) {
          pages.push(i);
        }
      }
      // Add last page and ellipsis if endPage is less than totalPages
      if (endPage < totalPages) {
        if (endPage < totalPages - 1) {
          if (endPage < totalPages - 2) {
            pages.push("..");
          }
          pages.push(totalPages - 1);
        }
        pages.push(totalPages);
      }
    }
    return pages;
  };
  const pageNumbers = getPageNumbers();
  return (
    <div className="pagination-outer mt-3">
      {totalPages > 1 ? (
        <div className="pagination-wrapper">
          {currentPage !== 1 && (
            <div className="next-prev-item" onClick={previousPage}>
              <i className="fa-solid fa-chevron-left" />
            </div>
          )}
          {pageNumbers.map((pageNumber, index) => {
            const isActive = pageNumber === currentPage;
            const isDisabled = pageNumber === "..";

            return (
              <div
                key={index}
                className={`pagination-item ${isActive ? "active" : ""} ${
                  isDisabled ? "disabled" : "cursor-pointer"
                }`}
                onClick={() => !isDisabled && handleChange(pageNumber)}
              >
                {pageNumber}
              </div>
            );
          })}

          {currentPage !== totalPages && (
            <div className="next-prev-item" onClick={nextPage}>
              <i className="fa-solid fa-chevron-right" />
            </div>
          )}
        </div>
      ) : null}
    </div>
  );
}
export default CustomPagination;
